module.exports = __webpack_public_path__ + "img/bottom.950b15fc.png";